import { useState } from "react";
import { SlidersHorizontal, X } from "lucide-react";
import { SelectField } from "@/lib/crm";
import { PeriodFilter } from "@/components/common/PeriodFilter";
import { Button } from "@/components/ui/button";

const FIELDS = [["company_id", "Cliente", "companies"], ["owner_id", "Responsabile", "owners"], ["technician_id", "Tecnico", "owners"], ["status", "Stato", "statuses"],
  ["category", "Categoria", "categories"], ["product_id", "Prodotto/servizio", "products"], ["priority", "Priorità", "priorities"], ["type", "Tipo", "types"], ["origin", "Origine", "origins"]];

// filtri globali condivisi da tutte le sezioni (stato nell'URL: si mantiene navigando nei dettagli e tornando indietro)
export const FilterBar = ({ f, set, reset, options }) => {
  const active = FIELDS.filter(([k]) => f[k]).length;
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-6 space-y-3" data-testid="analytics-filters">
      <div className="flex flex-wrap items-center gap-2">
        <PeriodFilter value={f.period || "month"} onChange={(v) => set("period", v)} testId="analytics-period" />
        <Button variant="outline" size="sm" className="h-8 gap-1 rounded-full text-xs sm:hidden" onClick={() => setOpen(!open)} data-testid="analytics-filters-toggle">
          <SlidersHorizontal className="h-3.5 w-3.5" />Filtri{active ? ` (${active})` : ""}</Button>
      </div>
      <div className={`${open ? "grid" : "hidden"} grid-cols-2 gap-2 sm:grid sm:grid-cols-3 lg:grid-cols-5`}>
        {FIELDS.map(([k, label, opt]) => (
          <SelectField key={k} value={f[k] || ""} onChange={(v) => set(k, v)} options={options?.[opt] || []} allowNone={label} testId={`analytics-filter-${k}`} />
        ))}
        {active > 0 && <Button variant="ghost" className="justify-start gap-1" onClick={reset} data-testid="analytics-filters-reset"><X className="h-4 w-4" />Azzera {active} filtri</Button>}
      </div>
    </div>
  );
};
